<template>
  <v-card class="partner-share">
    <v-card-title> Cómo compartir </v-card-title>
    <v-card-subtitle>
      Cualquier cliente que se registre luego de ingresar a algún link o
      escanear algún QR de abajo, quedará vinculado a su cuenta Partner
    </v-card-subtitle>
    <v-card-text>
      <v-row class="text-center">
        <v-col cols="12" md="6">
          <h4>Links a homepage de QueResto</h4>
          <p class="mb-3 grey--text">
            Use estos si quiere que sus clientes vean primero información de
            QueResto.com
          </p>
          <template v-if="homeQr">
            <div>
              <v-img class="d-inline-block partner-qr mb-2" :src="homeQr" />
            </div>
            <v-btn color="primary" @click="download('home')">Descargar</v-btn>
          </template>
          <v-text-field
            :value="homeLink"
            label="Dirección"
            ref="homeInput"
            class="mt-8"
            append-icon="mdi-content-copy"
            hide-details
            @click:append="copy('home')"
            outlined
            background-color="#fafafa"
            dense
            readonly
          />
        </v-col>
        <v-col cols="12" md="6">
          <h4>Links a creación de cuenta</h4>
          <p class="mb-3 grey--text">
            Use estos si ya les explicó a sus clientes sobre el sitio, y
            quiere que creen su cuenta directamente
          </p>
          <template v-if="signupQr">
            <div>
              <v-img class="d-inline-block partner-qr mb-2" :src="signupQr" />
            </div>
            <v-btn color="primary" @click="download('signup')">Descargar</v-btn>
          </template>
          <v-text-field
            :value="signupLink"
            label="Dirección"
            ref="signupInput"
            class="mt-8"
            append-icon="mdi-content-copy"
            hide-details
            @click:append="copy('signup')"
            outlined
            background-color="#fafafa"
            dense
            readonly
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn @click="$emit('close')">Cerrar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IPartnerToken } from '../../interfaces/IPartnerToken';
  import { Globals } from '../../modules/Globals';
  import { createQrBase64 } from '../../utils';
  import { saveAs } from 'file-saver';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';

  @Component
  export default class PartnerShareModal extends Vue {
    $refs: {
      homeInput: any;
      signupInput: any;
    };
    @Prop() token: IPartnerToken;
    website = Globals.website;
    homeQr = null;
    signupQr = null;

    async created() {
      this.homeQr = await createQrBase64(this.homeLink, 500);
      this.signupQr = await createQrBase64(this.signupLink, 500);
    }

    get homeLink() {
      return `${this.website}/info?pid=${this.token.id}`;
    }

    get signupLink() {
      return `${this.website}/admin/login?tab=signup&pid=${this.token.id}`;
    }

    copy(id: string) {
      const el = id === 'home' ? this.$refs.homeInput : this.$refs.signupInput;
      try {
        const input = el.$el.querySelector('input');
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        vueData.addAlert('Texto copiado al portapapeles', AlertType.Success);
      } catch (e) {
        console.error(e);
        vueData.addAlert('No se pudo copiar', AlertType.Error);
      }
    }

    download(id: string) {
      const qr = id === 'home' ? this.homeQr : this.signupQr;

      saveAs(qr, `${id}.png`);
    }
  }
</script>
